export const gloriafood = {
  seo: {
    title: 'Gloriafood stopt? Stap gratis over naar Bistroo',
    description:
      'Gloriafood stopt op 30 april 2027. Stap nu over naar Bistroo: gratis tot 1 mei 2027 en je eigen webshop live in minder dan 30 minuten.',
  },
  hero: {
    badge: 'Belangrijk voor Gloriafood-restaurants',
    title_1: 'Gloriafood stopt.',
    title_em: 'Je nieuwe thuis staat klaar.',
    subtitle:
      'Gloriafood stopt op 30 april 2027 met al zijn diensten. Duizenden restaurants hebben dan een nieuwe besteloplossing nodig. Bistroo staat klaar, en tot die dag betaal je niets.',
    offer_pt1: 'Gratis abonnement tot en met',
    offer_date: '30 april 2027',
    offer_pt2: ', de dag dat Gloriafood stopt.',
    cta_primary: 'Maak mijn webshop, gratis',
    cta_secondary: 'Praat met ons team',
    reassurance: 'Geen creditcard nodig. Live in minder dan 30 minuten. Maandelijks opzegbaar.',
  },
  countdown: {
    label: 'Resterende tijd tot Gloriafood stopt',
    units: {
      months: 'maanden',
      days: 'dagen',
      hours: 'uur',
      minutes: 'minuten',
    },
    cta_text: 'Elke dag wachten is een dag dichter bij een webshop die offline gaat.',
    cta_link: 'Stap vandaag over',
  },
  trust: {
    items: [
      { icon: 'bi-lightning-charge-fill', text: 'Live in minder dan 30 minuten' },
      { icon: 'bi-credit-card-2-front-fill', text: 'Geen opstartkosten' },
      { icon: 'bi-unlock-fill', text: 'Geen langlopend contract' },
      { icon: 'bi-headset', text: 'Persoonlijke hulp bij de overstap' },
    ],
  },
  timeline: {
    kicker: 'Wat er gebeurt',
    heading: 'De klok tikt voor Gloriafood-restaurants',
    lead: 'Dit is wat je moet weten, en wat je nu het beste doet.',
    items: [
      {
        icon: 'bi-megaphone-fill',
        date: 'Nu',
        title: 'Gloriafood kondigt het einde aan',
        text: 'Gloriafood heeft aangekondigd te stoppen met al zijn diensten. Duizenden restaurants moeten daarom op zoek naar een nieuwe oplossing voor online bestellen.',
      },
      {
        icon: 'bi-exclamation-triangle-fill',
        date: '30 april 2027',
        title: 'De servers van Gloriafood gaan uit',
        text: "Alle webshops, websites en bestelpagina's die op Gloriafood draaien, stoppen met werken. Geen bestellingen meer, geen omzet meer.",
      },
      {
        icon: 'bi-check-circle-fill',
        date: 'Vandaag',
        title: 'Stap kosteloos over naar Bistroo',
        text: 'Meld je nu aan en gebruik je volledige Bistroo-webshop gratis tot 30 april 2027. Zo stap je in je eigen tempo over, zonder haast en zonder dubbele kosten.',
      },
    ],
  },
  why: {
    kicker: 'De juiste keuze',
    heading: 'Waarom Bistroo het logische alternatief is voor Gloriafood',
    lead: 'Geen zoveelste webshop-tool. Bistroo is vanaf de basis gebouwd voor restaurants zoals dat van jou.',
    items: [
      {
        title: 'Je webshop is volledig van jou',
        text: 'Jouw merk, jouw domein, jouw gastgegevens. Er staat geen marktplaats tussen jou en je gasten: bestellingen, omzet en relaties blijven bij jou.',
      },
      {
        title: 'Next-gen design, direct klaar voor gebruik',
        text: 'Bistroo-webshops zien er écht modern uit. Met aanpasbare templates laat je webshop de kwaliteit van je eten zien, in plaats van een generieke bestelpagina uit 2015.',
      },
      {
        title: 'Een complete suite, tegen een toegankelijke prijs',
        text: 'Webshop, website, QR-bestellen, kiosk en kassa horen bij hetzelfde ecosysteem. Eén maandabonnement, transparante tarieven, alles beheerd in de Bistroo Manager.',
      },
      {
        title: 'Een partner, geen leverancier',
        text: 'Bistroo is maandelijks opzegbaar, omdat we je vertrouwen elke maand opnieuw willen verdienen. Geen lock-in en geen verrassingen achteraf.',
      },
    ],
  },
  features: {
    kicker: 'Waarom Bistroo',
    heading: 'Alles wat je bij Gloriafood had en meer',
    lead: 'Speciaal gebouwd voor quick-service, afhalen en bezorgen. Geen bijzaak, maar precies waar onze software voor bedoeld is.',
    items: [
      {
        icon: 'bi-shop',
        title: 'Een webshop in je eigen huisstijl',
        text: 'Eigen domein, eigen kleuren en aanpasbare templates. Gasten bestellen rechtstreeks bij jou, niet via een marktplaats.',
      },
      {
        icon: 'bi-phone',
        title: 'Volledig orderbeheer',
        text: "Accepteer, beheer en volg elke bestelling realtime in de Bistroo Manager. Menu's, openingstijden en prijzen pas je zelf direct aan.",
      },
      {
        icon: 'bi-cash-coin',
        title: 'Transparante, eerlijke tarieven',
        text: 'Een maandabonnement zonder verrassingen. Je weet altijd waar je aan toe bent en je gastgegevens blijven van jou.',
      },
      {
        icon: 'bi-lightning-charge',
        title: 'Self-service, plug & play',
        text: 'Geen developer nodig. Zet je menu op, koppel je uitbetalingen via Stripe en ga live, allemaal binnen 30 minuten.',
      },
      {
        icon: 'bi-globe-europe-africa',
        title: 'Groeit met je mee door Europa',
        text: 'Actief in Nederland en België, later in 2026 ook in Duitsland. Gebouwd om mee te groeien met jouw ambities.',
      },
      {
        icon: 'bi-headset',
        title: 'Persoonlijke klantenservice',
        text: 'Een echt team dat opneemt. We zijn er wanneer het het drukst is en het er het meest op aankomt.',
      },
    ],
  },
  offer: {
    heading: 'Gratis tot de laatste dag van Gloriafood.',
    text: 'Stap nu over en betaal niets tot 1 mei 2027. Je abonnement start pas op het moment dat Gloriafood stopt, niet eerder.',
    button: 'Claim je gratis periode',
    note: '* Het aanbod geldt voor het standaard Bistroo Webshop-abonnement, voor restaurants die vóór 30 april 2027 overstappen van Gloriafood.',
  },
  steps: {
    kicker: 'In 3 stappen',
    heading: 'Online in minder dan 30 minuten',
    items: [
      {
        title: 'Maak je gratis account',
        text: 'Meld je aan op merchant.bistroo.nl. Geen creditcard, geen verplichtingen. Klaar in 2 minuten.',
      },
      {
        title: 'Zet je menu en webshop op',
        text: 'Voer je menu in, kies een template en stel je domein en openingstijden in. Alles zelf, via de Bistroo Manager.',
      },
      {
        title: 'Ga live en ontvang bestellingen',
        text: 'Koppel Stripe voor je uitbetalingen, publiceer je webshop en deel je link of QR-code met je gasten.',
      },
    ],
    button: 'Start mijn gratis webshop',
  },
  contact: {
    kicker: 'Praat met ons team',
    heading: 'Liever een persoonlijke introductie?',
    lead: 'Laat je gegevens achter en een van onze restaurantspecialisten neemt binnen één werkdag contact op om je door de overstap te loodsen. Kosteloos.',
    perks: [
      'We helpen je je menu over te zetten vanuit Gloriafood',
      'Gratis hulp bij het inrichten van je webshop-design',
      'Geen abonnementskosten tot 1 mei 2027',
      'Maandelijks opzegbaar, zonder langlopend contract',
    ],
    card: {
      title: 'Vraag je overstap aan',
      text: 'Vul het contactformulier in en we nemen binnen één werkdag contact met je op. Wil je liever eerst zelf rondkijken? Maak dan direct je gratis account aan.',
      button: 'Naar het contactformulier',
      secondary: 'Direct gratis account aanmaken',
      disclaimer: 'We reageren binnen één werkdag. Nooit spam.',
    },
  },
  faq: {
    title_pt1: 'Veelgestelde vragen over',
    title_pt2: 'de overstap',
    items: [
      {
        q: 'Hoe werkt de gratis periode precies?',
        a: 'Meld je vóór 30 april 2027 aan en geef aan dat je overstapt van Gloriafood. Wij activeren je account zonder abonnementskosten tot 1 mei 2027. Daarna geldt het standaard maandabonnement, dat je elke maand kunt opzeggen.',
      },
      {
        q: 'Kan ik mijn menu meenemen vanuit Gloriafood?',
        a: "Ja. Neem contact op met ons team, dan helpen we je bij het overzetten. Wil je het liever zelf doen? Met de menu-builder in de Bistroo Manager zet je je categorieën, opties, foto's en prijzen snel klaar.",
      },
      {
        q: 'Heb ik technische kennis nodig om over te stappen?',
        a: 'Nee. Bistroo is volledig self-service: de Bistroo Manager is zo gebouwd dat je als restauranthouder alles zelf instelt en beheert, zonder developer. Loop je toch vast, dan helpt ons supportteam je persoonlijk verder.',
      },
      {
        q: 'Wat gebeurt er na de gratis periode?',
        a: 'Vanaf 1 mei 2027 ga je over op het standaard maandabonnement van Bistroo. Je kunt op elk moment wijzigen of opzeggen; we werken niet met langlopende contracten.',
      },
      {
        q: 'Is Bistroo beschikbaar in mijn land?',
        a: 'Bistroo is live in Nederland en België, en later in 2026 lanceren we in Duitsland. Zit je daarbuiten? Neem contact op, dan houden we je op de hoogte van onze uitbreiding.',
      },
    ],
  },
  cta: {
    heading_1: 'Wacht niet tot het licht uitgaat.',
    heading_em: 'Stap vandaag over.',
    text: '30 minuten om in te stellen. Gratis tot Gloriafood stopt. Geen risico.',
    button_primary: 'Start mijn gratis webshop',
    button_secondary: 'Neem contact op',
  },
}
